import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { CommonMap } from '../../../../../../_shared/components/common-map/common-map.component';
import { ACCIDENTS_EMPTY_VALUE } from '../../../constants/accidents-and-incidents.constants';
import { IncidentMarkerFactory } from './incident-marker-factory.helper';

@Component({
  selector: 'app-incident-details-modal',
  standalone: true,
  imports: [
    CommonModule,
    CommonMap,
    TranslocoDirective,
    TranslocoPipe
  ],
  templateUrl: './incident-details-modal.component.html',
  styleUrl: './incident-details-modal.component.scss'
})
export class IncidentDetailsModalComponent implements OnInit {
  @Input() title: string = '';
  @Input() latitude: number | null = null;
  @Input() longitude: number | null = null;
  @Input() locationText: string = '';

  private activeModal: NgbActiveModal = inject(NgbActiveModal);

  readonly emptyValue = ACCIDENTS_EMPTY_VALUE;
  readonly coordinateFormat = '1.4-4';
  readonly mapHeight = '422px';
  readonly markerFactory = new IncidentMarkerFactory();

  mapCenter: google.maps.LatLngLiteral | null = null;
  mapData: google.maps.LatLngLiteral[] = [];

  ngOnInit(): void {
    if (typeof this.latitude === 'number' && typeof this.longitude === 'number') {
      this.mapCenter = { lat: this.latitude, lng: this.longitude };
      this.mapData = [this.mapCenter];
    }
  }

  close(): void {
    this.activeModal.dismiss();
  }
}